import React, { useState } from "react";
import tgt_logo from "../../assets/common/logo.png";
import "../login/login.scss";
import { Link } from "react-router-dom";
import usePost from "../../customHooks/usePost/UsePost";
import CustomToast from "../../atomic/customToast/CustomToast";

const Signup = () => {
  const [formDataState, setFormDataState] = useState({});
  const post = usePost();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState({ ...formDataState, [name]: value });
  };
  const onSuccess = (data) => {
    if (data.success === true) {
      CustomToast({ type: "success", message: `Signup successfully` });

      const storedData = JSON.stringify(data?.data);
      localStorage.setItem("local_data", storedData);
      window.location.href = "/"
    } else {
      const mail = data.response.email ? data?.response?.email[0] : "";
      const pass = data?.response?.password ? data?.response?.password[0] : "";

      CustomToast({ type: "error", message: `${mail} ${pass}` });
    }
   
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (formDataState.password === formDataState.cPassword) {
      await post.postData("signup", formDataState, onSuccess);
    } else {
      CustomToast({
        type: "error",
        message: `password and confirm password does not match`,
      });
    }
  };
  return (
    <div className=" login d-flex flex-column justify-content-center text-center">
      <div className="logo">
        <img
          src={tgt_logo}
          alt="tgt Logo - Uploading"
          className="w-100 h-100"
        />
      </div>
      <h1 class="my-3 text-xl bold capitalize text-gray-900">
        Create A New Account
      </h1>
      <p class="mb-4">
        Already have an account?{" "}
        <Link class="" to="/signin">
          login
        </Link>
      </p>
      <div className="card p-4">
        <form onSubmit={onSubmit}>
          <div>
            <label for="Name">
              First and Last Name <span class="text-danger">*</span>
            </label>
            <input
              required
              label="First and Last Name"
              type="text"
              id="Name"
              name="name"
              value={formDataState?.name}
              onChange={handleChange}
            />
          </div>
          <div>
            <label for="Email">
              Email <span class="text-danger">*</span>
            </label>
            <input
              required
              label="Email"
              type="email"
              name="email"
              id="Email"
              value={formDataState?.email}
              onChange={handleChange}
            />
          </div>
          <div>
            <label for="Password">
              Password <span class="text-danger">*</span>
            </label>
            <input
              required
              label="Password"
              type="password"
              name="password"
              id="Password"
              value={formDataState?.password}
              onChange={handleChange}
            />
          </div>
          <div>
            <label for="cPassword">
              Confirm Password <span class="text-danger">*</span>
            </label>
            <input
              required
              label="cPassword"
              type="password"
              name="cPassword"
              id="cPassword"
              value={formDataState?.cPassword}
              onChange={handleChange}
            />
          </div>
          <button className="btn btn-primary my-3 w-100" type="submit">
            Create Account
          </button>
        </form>
      </div>
    </div>
  );
};

export default Signup;
